/*
Model defined for Maintaining Account Request and Response. It can also be used for transferring model
*/

export class AccountResponseModel2 {
    id: string;
    holdername: string;
    accountHolderName: string;
    accountNumber: string;
    branch: string;
    bank: string;
    ifsc: string;
    verified: string;
    partnerId: string;
    bankAccountType: string;
}
export class EmailResponseModel {
    consumerId: string;
    emailId: string;
}
export class AccountResponseModel {
    accountHolderName: string;
    accountNumber: string;
    bank: string;
    branch: string;
    branchAccounts: BranchAccount[];
    createdAt: string;
    defaultCategory: string;
    id: string;
    ifsc: string;
    partnerId: string;
    status: string;
    type: string;
    updatedAt: string;
    bankId: string;
}

interface BranchAccount {
    accountId: string;
    branchId: string;
    createdAt: string;
    updatedAt: string;
}
export class PanRequestModel {
    pan: string;
    orderId: string;
}

export class ConsumerBankAccRequest {
    bankName: string;
    default: 'true';
    number: string;
    ifscCode: string;
    type: 'SAVINGS';
    branch: string;
    isDefault: 'true';
    consumerId: string;
    nameAsPerAccountNumber: string;
    mobileNo: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/account/AccountResponseModel.ts